import SimpleEvent from './../../zviz2/zviz/event';
import {scrollTo} from './../../tools';

class Component{

    constructor(){
        
        this.parentElement = document.getElementById('indicatorMenu');
        let elms = this.parentElement.getElementsByClassName('content');
        this.element = elms[0];
        this.container = null;
        this.currentId = '';

        let nodes = this.parentElement.parentNode.childNodes;
        for(let i = 0; i < nodes.length; i++){
            if(nodes[i].className && nodes[i].className == 'text'){
                this.container = nodes[i];
                break;
            }
        }

        this.events = [];
        this.events.push(new SimpleEvent(window, 'resize', [this, this.setParentPosition]));
        this.events.push(new SimpleEvent(window, 'scroll', [this, this.setPosition]));
        this.events.push(new SimpleEvent(window, 'hashchange', [this, this.hashChange]));

        let els = document.getElementById('indicatorSelect');
        this.events.push(new SimpleEvent(els, 'change', [this, this.setMobileIndicator]));

        this.setParentPosition();
        this.setPosition();

        let items = this.container.getElementsByClassName('subtheme');
        let found = this.hashChange({preventDefault: function(){}});
        if(! found && items[0]){
            this.setIndicator(null, items[0].id);
        }
        for(let i = 0; i < items.length; i++){
            let nav = items[i].getElementsByClassName('indicatorNav');
            for(let c = 0; c < nav.length; c++){
                let p = nav[c].getElementsByClassName('previous');
                if(p[0] && i > 0){
                    p[0].setAttribute('rel', items[i-1].id);
                    this.events.push(new SimpleEvent(p[0], 'click', [this, this.setIndicator]));
                }else{
                    p[0].className += ' disabled';
                    this.events.push(new SimpleEvent(p[0], 'click', [this, this.disabledEvent]));
                }
                let n = nav[c].getElementsByClassName('next');
                if(n[0] && i < items.length-1){
                    n[0].setAttribute('rel', items[i+1].id);
                    this.events.push(new SimpleEvent(n[0], 'click', [this, this.setIndicator]));
                }else{
                    n[0].className += ' disabled';
                    this.events.push(new SimpleEvent(n[0], 'click', [this, this.disabledEvent]));
                }
            }
        }

        els = this.element.getElementsByClassName('indicatorSelect');
        for(let i = 0; i < els.length; i++){
            this.events.push(new SimpleEvent(els[i], 'click', [this, this.setIndicator]));
        }

        els = this.element.getElementsByClassName('themeSelect');
        for(let i = 0; i < els.length; i++){
            this.events.push(new SimpleEvent(els[i], 'click', [this, this.setTheme]));
        }
    }

    hashChange(event){
        let hash = window.location.hash || '';
        if(hash.length > 6 && hash.substring(1, 5) == 'ind_'){
            let id = hash.substring(5);
            if(id != this.currentId){
                return this.setIndicator(event, id);
            }
        }
        return false;
    }

    setParentPosition(){
        let textPos = this.container.getBoundingClientRect();
        this.parentElement.style.width = (textPos.left + 280) + 'px';
    }

    setPosition(){

    }

    disabledEvent(event){
        event.preventDefault();
    }

    setTheme(event){
        let elm = event.currentTarget;
        if(elm.className.indexOf('selected') == -1){
            let ind = elm.getElementsByClassName('indicatorSelect');
            if(ind[0]){
                let id = ind[0].getAttribute('rel');
                this.setIndicator(event, id);
            }
        }
    }

    setMobileIndicator(event){
        let id = event.currentTarget.value;
        this.setIndicator(event, id, -300);
    }

    setIndicator(event, id=null, scrollOffset=30){
        if(event){
            event.preventDefault();

            let link = document.getElementById('indicatorMenu');
            if(link){
                let c = scrollTo(link.parentNode, 300, true, scrollOffset);
                c.start();
            }
        }
        if(id == null){
            id = event.currentTarget.getAttribute('rel');
        }
        if(! document.getElementById(id)){
            return false;
        }
        if(event){
            this.currentId = id;
            window.location.hash = '#ind_' + id;
            let elm = document.getElementById(id);
            let title = elm.getAttribute('data-title') || id;
            zolabo.trackEvent('indicator', (window.themeId || 'theme'), title);
        }
        
        let els = [].slice.apply(this.element.getElementsByClassName('selected'));
        for(let i = 0; i < els.length; i++){
            els[i].className = els[i].className.replace(/selected/g, '').trim();
        }
        els = this.element.getElementsByClassName('indicatorSelect');
        for(let i = 0; i < els.length; i++){
            let rel = els[i].getAttribute('rel');
            if(rel && rel == id){
                els[i].className += ' selected';
                els[i].parentNode.parentNode.className += ' selected';
                break;
            }
        }

        els = [].slice.apply(this.container.getElementsByClassName('active'));
        for(let i = 0; i < els.length; i++){
            els[i].className = els[i].className.replace(/active/g, '').trim();
            if(pageVideos){
                let close = els[i].getElementsByClassName('closeVideo');
                for(let c of close){
                    pageVideos.closeVideo(c);
                }
            }
        }
        els = this.container.getElementsByClassName('subtheme');
        for(let i = 0; i < els.length; i++){
            if(els[i].id && els[i].id == id){
                els[i].className += ' active';
                break;
            }
        }

        if(zolabo.visualizations['indicator-' + id]){
            if(zolabo.visualizations['indicator-' + id] instanceof Array){
                let vs = zolabo.visualizations['indicator-' + id];
                for(let i = 0; i < vs.length; i++){
                    vs[i].reset();
                }
            }else{
                zolabo.visualizations['indicator-' + id].reset();
            }
        }

        els = document.getElementById('indicatorSelect');
        if(els){
            els.value = id;
        }

        return true;
    }

    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}    

export default Component;
